import React, { useState, useEffect } from 'react';
import { Copy } from 'lucide-react';
import api from '../utils/api';

const WidgetIntegration = () => {
  const [widgetConfig, setWidgetConfig] = useState({
    position: 'bottom-right',
    theme: 'light',
    primaryColor: '#007bff',
    welcomeMessage: 'Hello! How can I help you today?',
    iconUrl: ''
  });
  const [embedCode, setEmbedCode] = useState('');
  
  // Derive URLs from environment
  const backendUrl = process.env.REACT_APP_API_BASE_URL?.replace('/api', '') 
  
  
  ;
  const frontendUrl = backendUrl;

  useEffect(() => {
    const generateEmbedCode = async () => {
      // Update widget config first
      await api.updateWidgetConfig(widgetConfig);
      
      // Generate embed code using derived URLs
      
      const embedCode = `<script src="${frontendUrl}/widget.js"></script>
<script>
  ChatWidget.init({
    apiUrl: '${backendUrl}',
    title: 'Apna Assistant',
    welcomeMessage: '${widgetConfig.welcomeMessage}',
    position: '${widgetConfig.position}',
    theme: '${widgetConfig.theme}',
    primaryColor: '${widgetConfig.primaryColor}'
  });
</script>`;
      
      setEmbedCode(embedCode);
    };
    
    generateEmbedCode();
  }, [widgetConfig]);

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(embedCode);
      alert('Code copied to clipboard!');
    } catch (error) {
      console.error('Error copying embed code:', error);
      alert('Failed to copy code');
    }
  };

  return (
    <div className="container">
      <h1>Widget Integration</h1>
      
      <div className="card">
        <h3>Widget Configuration</h3>
        
        <div className="form-group">
          <label className="form-label">Position</label>
          <select 
            className="form-input"
            value={widgetConfig.position}
            onChange={(e) => setWidgetConfig({...widgetConfig, position: e.target.value})}
          >
            <option value="bottom-right">Bottom Right</option>
            <option value="bottom-left">Bottom Left</option>
            <option value="top-right">Top Right</option>
            <option value="top-left">Top Left</option>
          </select>
        </div>

        <div className="form-group">
          <label className="form-label">Theme</label>
          <select 
            className="form-input"
            value={widgetConfig.theme}
            onChange={(e) => setWidgetConfig({...widgetConfig, theme: e.target.value})}
          >
            <option value="light">Light</option>
            <option value="dark">Dark</option>
          </select>
        </div>

        <div className="form-group">
          <label className="form-label">Primary Color</label>
          <input 
            type="color"
            className="form-input"
            value={widgetConfig.primaryColor}
            onChange={(e) => setWidgetConfig({...widgetConfig, primaryColor: e.target.value})}
          />
        </div>

        <div className="form-group">
          <label className="form-label">Welcome Message</label>
          <input 
            type="text"
            className="form-input"
            value={widgetConfig.welcomeMessage}
            onChange={(e) => setWidgetConfig({...widgetConfig, welcomeMessage: e.target.value})}
            placeholder="Enter welcome message"
          />
        </div>

        <div className="form-group">
          <label className="form-label">Chatbot Icon URL</label>
          <input 
            type="url"
            className="form-input"
            value={widgetConfig.iconUrl}
            onChange={(e) => setWidgetConfig({...widgetConfig, iconUrl: e.target.value})}
            placeholder="Enter icon URL (leave empty for default emoji)"
          />
        </div>
      </div>

      <div className="card">
        <h3>Embed Code</h3>
        <p style={{ marginBottom: '16px', color: '#666' }}>
          Copy and paste this code into your website's HTML to integrate the chatbot widget.
          <br />
          <small style={{ color: '#999' }}>Widget is served from frontend ({backendUrl}), API calls go to backend ({process.env.REACT_APP_API_BASE_URL})</small>
        </p>
        
        <div style={{ position: 'relative' }}>
          <pre style={{ 
            background: '#f8f9fa', 
            padding: '16px', 
            borderRadius: '4px', 
            overflow: 'auto',
            fontSize: '12px',
            border: '1px solid #e9ecef'
          }}>
            <code>{embedCode || 'Generating embed code...'}</code>
          </pre>
          
          <button 
            className="btn btn-primary"
            onClick={copyToClipboard}
            style={{ 
              position: 'absolute', 
              top: '10px', 
              right: '10px',
              display: 'flex',
              alignItems: 'center',
              gap: '4px'
            }}
          >
            <Copy size={16} />
            Copy
          </button>
        </div>
      </div>

      <div className="card">
        <h3>Preview</h3>
        <div style={{ 
          border: '1px solid #ddd', 
          borderRadius: '4px', 
          padding: '20px',
          background: '#f8f9fa',
          position: 'relative',
          height: '300px'
        }}>
          <p style={{ color: '#666', textAlign: 'center', marginTop: '120px' }}>
            Widget preview will appear here
          </p>
          
          {/* Mock widget preview */}
          <div style={{
            position: 'absolute',
            [widgetConfig.position.includes('bottom') ? 'bottom' : 'top']: '20px',
            [widgetConfig.position.includes('right') ? 'right' : 'left']: '20px',
            width: '60px',
            height: '60px',
            borderRadius: '50%',
            background: widgetConfig.primaryColor,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'white',
            cursor: 'pointer',
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            overflow: 'hidden'
          }}>
            {widgetConfig.iconUrl ? (
              <img 
                src={widgetConfig.iconUrl} 
                alt="Chatbot" 
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  borderRadius: '50%'
                }}
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'block';
                }}
              />
            ) : null}
            <span style={{
              display: widgetConfig.iconUrl ? 'none' : 'block',
              fontSize: '24px'
            }}>💬</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WidgetIntegration;